// extracted by mini-css-extract-plugin
module.exports = {"etLogo":"LogoLayout_etLogo__2tx3p","etLogoWrapper":"LogoLayout_etLogoWrapper__IG3oQ","etLogoImage":"LogoLayout_etLogoImage__OX6IT"};